import styled from '@emotion/styled';
import { space } from 'folio-common-components';

export const WarningBox = styled.div`
  background: var(--blue-200);
  ${space([16], 'padding')};
  border-radius: var(--border-radius);
`;
